import * as React from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import styles from 'assets/css/Hypo.module.css';
import { digitsEnToFa, digitsFaToEn } from 'persian-tools2';
import {usePatientInfo} from "hooks/usePatient";

export const HypoButton=({active,setActive,patientId})=> {
    const {data: patientInfo} = usePatientInfo(patientId);
    const {isPregnant} = patientInfo || {}
  const totalClick = () => {
    setActive('total');
  };
  const level2Click = () => {
    setActive('level');
  };
  return (
    <ButtonGroup variant="text" dir="ltr" className={styles.ButtonGroup}>
      <Button
        className={styles.hypoButton}
        style={{
          backgroundColor: active === 'total' ? '#753CBE26' : 'transparent',
          color: active === 'total' ? '#6F4D9F' : '#4D4D4E',
          border: 0,
        }}
        onClick={totalClick}
      >
        {digitsEnToFa(`( < ${isPregnant?60:70} )`)} تمام هایپو ها
      </Button>
      <Button
        className={styles.hypoButton}
        style={{
          backgroundColor: active === 'level' ? '#753CBE26' : 'transparent',
          color: active === 'level' ? '#6F4D9F' : '#4D4D4E',
        }}
        onClick={level2Click}
      >
        {digitsEnToFa('( < 54 )')} سطح ۲ هایپوها
      </Button>
    </ButtonGroup>
  );
};
